import React from 'react';
import PropTypes from 'prop-types';

const CustomNoRowsOverlay = ({ message, showEnteredValue = false, ...gridApiPropsMostUnnecessary }) => {
  // This block is used so we don't have to have propTypes for all these unnecessary props. -PaU
  const {
    addRenderedRowListener,
    addRowCompListener,
    agGridReact,
    api,
    colDef,
    columnApi,
    eGridCell,
    eParentOfValue,
    formatValue,
    frameworkComponentWrapper,
    getValue,
    reactContainer,
    refreshCell,
    rowIndex,
    setValue,
    valueFormatted,
    ...onlyExtraProps
  } = gridApiPropsMostUnnecessary;

  const filterValue = (api?.filterManager?.quickFilter || '').toLowerCase();

  return (
    <span className="ag-cell__text ag-cell__text--overlay-text" {...onlyExtraProps}>
      {message}
      {showEnteredValue && <strong>{` "${filterValue}"`}</strong>}
    </span>
  );
};

CustomNoRowsOverlay.propTypes = {
  /** Message for no rows found overlay */
  message: PropTypes.node.isRequired,
  /** If true, adds the search value to the end of the message */
  showEnteredValue: PropTypes.bool,
};

export { CustomNoRowsOverlay };
